// extracted by mini-css-extract-plugin
export default {"flags-advanced-search-table":"flagsAdvancedSearch_flags-advanced-search-table__JSswi"};